/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles/";
import { debounce } from "lodash";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import ImagemDefault from "../../../../../../assets/images/map-default.svg";
import { AdminTitle } from "../../../../../../pages/admin/components/AdminTitle";
import HeaderButton from "../../../../../../pages/admin/components/headerButton";
import RefreshButton from "../../../../../../pages/admin/components/RefreshButton";
import Loading from "../../../../../../pages/home/components/Loading";
import {
  Portlet,
  PortletBody,
} from "../../../../../../partials/content/Portlet";
import globalColors from "../../../../../../../_metronic/_assets/sass/custom/globalColors.scss";
import { AppAPIService } from "../../../../../../services/AppAPIService";
import {
  IconButton,
  Grid,
  SvgIcon,
  InputAdornment,
  Container,
} from "@material-ui/core";

import InputForm from "../../../../../../components/InputForm/index";
import InputDateForm from "../../../../../../components/InputDateForm/index";
import { ReactComponent as LastPageIcon } from "../../../../../../assets/custom-icons/cheveron-last-right.svg";
import { ReactComponent as FirstPageIcon } from "../../../../../../assets/custom-icons/cheveron-first-left.svg";
import { ReactComponent as NextPageIcon } from "../../../../../../assets/custom-icons/cheveron-right.svg";
import { ReactComponent as PreviousPageIcon } from "../../../../../../assets/custom-icons/cheveron-left.svg";
import { ReactComponent as SearchIcon } from "../../../../../../assets/custom-icons/search-icon.svg";
import {
  ImageContainer,
  OpenContainerButton,
  StyledTableCell,
  StyledTableContent,
  StyledTableRow,
} from "./styles";
import "./styles.css";

const EnhancedTableHead = (props) => {
  const { headRows } = props;

  const generateRow = (headRows) => (
    <TableRow>
      {(headRows || []).map((row, i) => (
        <TableCell
          key={row.column || i}
          align={row.align ? row.align : "left"}
          padding={row.disablePadding ? "none" : "default"}
          size={row.size || null}
          width={row.width || undefined}
          variant="head"
          style={{
            textAlign: row.align ? row.align : "left",
            backgroundColor: globalColors.secondaryColor3,
            fontWeight: "600",
          }}
          component={StyledTableCell}
        >
          {row.label}
        </TableCell>
      ))}
    </TableRow>
  );

  return (
    <TableHead
      style={{
        backgroundColor: globalColors.secondaryColor3,
      }}
    >
      {Array.isArray(headRows[0]) &&
        headRows.map((row) => {
          return generateRow(row);
        })}
      {!Array.isArray(headRows[0]) && generateRow(headRows)}
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  rowCount: PropTypes.number.isRequired,
  headRows: PropTypes.array.isRequired,
};

const api = AppAPIService.getInstance();

const DatatableDocuments = (props) => {
  const { widthTable } = props;
  const useStyles = makeStyles(() => {
    return {
      root: {
        //tabela e pesquisa
        maxHeight: "fit-content",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        minHeight: props.removeMinHeight ? "fit-content" : "75vh",
        borderRadius: "4px",
      },
      paper: {
        width: "100%",
        flex: "1",
      },
      table: {
        minWidth: widthTable ? widthTable : 400,
        overflowX: "scroll",
        background: `${globalColors.backgroundColor6}40`,
        // cor do hover/caeçalho da tabela
        // boxShadow:
        //   "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
      },
      tableWrapper: {
        overflow: "hidden !important",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100%",
        overflowX: "auto",
        borderRadius: "4px",
        boxShadow: props.removeShadow
          ? "none"
          : "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
        border: "none",
      },
      tableContainer: {
        padding: props.removePadding ? 0 : "0 16px 0px 16px",
        marginTop: "5px",
      },
      search: {
        padding: props.removePadding ? "16px 0" : 16,
      },
      input: {
        border: `.5px solid ${globalColors.backgroundColor2}`,
        paddingRight: "10px",
        borderRadius: "4px",
        height: "48px",
        marginRight: "10px",
      },
      rows: {
        padding: "0 !important",
        margin: "0 !important",
      },
      addBtn: {
        padding: "16px 0",
        marginLeft: "16px",
      },
    };
  });

  const classes = useStyles();
  const currentState = loadPaginationState();

  const [rows, setRows] = useState(props.rows);

  const [order] = useState(currentState.order || "desc");
  const [orderBy] = useState(
    currentState.orderBy || props.orderBy || props.headRows[0].column || "Id"
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    props.rowsPerPage || currentState.perPage || 10
  );
  const [count, setCount] = useState(rows?.length);
  const [inputSearch, setInputSearch] = useState(props.search || "");
  const [optionFilter] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const [isLoadingExport, setIsLoadingExport] = useState("");
  const [reload, setReload] = useState(false);
  const pageCurrentState = currentState.page;
  const [isOpen, setIsOpen] = useState(false);

  const [selectedType, setSelectedType] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);

  const typeOptions = [
    { value: "validating", label: "validando" },
    { value: "pending", label: "pendente" },
    { value: "completed", label: "completo" },
    { value: "rejected", label: "rejeitado" },
  ];
  const handleTypeChange = async (selectedValue) => {
    await setSelectedType(selectedValue);
  };

  const handleDateChange = async (date) => {
    await setSelectedDate(date);
  };

  function searchLoad(e) {
    loadRecords({
      page: 0,
      search: e,
    });
  }

  const onSearch = useRef(
    debounce((e, searchLoad) => {
      searchLoad(e);
    }, 500)
  ).current;

  function search(e, select) {
    props.localSearch || select
      ? onSearch(e.target.value, (e) => props.localFilter(select, e, setCount))
      : onSearch(e.target.value, (e) => searchLoad(e));
  }

  const showMap = () => setIsOpen(!isOpen);

  async function exportRecords(config = {}) {
    setIsLoadingExport(true);

    let params = {
      page: (config.page !== undefined ? config.page : page) + 1,
      perPage: config.perPage || rowsPerPage,
      search: config.search,
      where: config.status ? config.status.join(", ") : "",
    };

    await api.download(
      {
        url: config.isEndpointFull
          ? config.endpoint || ""
          : props.endpoint + (config.endpoint || ""),
        params,
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );

    setIsLoadingExport(false);
  }

  const loadRecords = useCallback(
    async (config = {}) => {
      !config.search && setIsLoading(true);

      let params = props.contractInputFilter
        ? {
            page: (config.page !== undefined ? config.page : page) + 1,
            perPage: config.perPage || rowsPerPage,
            orderBy: config.orderBy || orderBy,
            orderByDirection: config.orderByDirection || order,
            search: config.search,
          }
        : {
            page: (config.page !== undefined ? config.page : page) + 1,
            perPage: config.perPage || rowsPerPage,
            search: config.search,
            optionFilter: optionFilter,
          };
      try {
        let response = {};
        let endpointUrl = props.endpoint;

        if (selectedType) {
          endpointUrl += `?status=${selectedType.value}`;
        }

        if (selectedDate) {
          if (selectedType) {
            endpointUrl += `&limitDate=${selectedDate}`;
          } else {
            endpointUrl += `?limitDate=${selectedDate}`;
          }
        }
        console.log(endpointUrl);
        response = await api.makeHttpRequest({
          url: endpointUrl,
          params,
        });

        setRows(response?.data || response);
        setCount(response?.meta?.total || response.length);

        setPage(
          params.page < response.meta.lastPage
            ? response.meta.currentPage - 1 > 0
              ? response.meta.currentPage - 1
              : 0
            : response.meta.lastPage - 1 > 0
            ? response.meta.lastPage - 1
            : 0
        );
      } catch (e) {
        Swal.fire(
          "Erro!",
          "Erro ao carregar os dados, tente novamente mais tarde.",
          "error"
        );
      } finally {
        setIsLoading(false);
        setReload(false);
      }
    },
    [
      optionFilter,
      order,
      orderBy,
      page,
      props.contractInputFilter,
      props.endpoint,
      rowsPerPage,
      selectedType,
      selectedDate,
    ]
  );

  useEffect(() => {
    if (!props.cancelReload) {
      loadRecords({
        page:
          props.skipPaginationState === false ? pageCurrentState || page : page,
        search: props.search || inputSearch,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, props.reload]);

  useEffect(() => {
    if (Boolean(props.dateRange)) {
      loadRecords({
        page:
          props.skipPaginationState === false ? pageCurrentState || page : page,
        search: props.search || inputSearch,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.dateRange]);

  useEffect(() => {
    loadRecords({
      search: inputSearch,
    });
  }, [inputSearch, loadRecords]);

  function loadPaginationState() {
    const paginationState = JSON.parse(
      localStorage.getItem("pagination") || "{}"
    );
    if (paginationState[props.endpoint]) {
      return paginationState[props.endpoint];
    }

    return {};
  }

  function handleChangePage(_, newPage) {
    setPage(newPage);
    loadRecords({ page: newPage, search: inputSearch });
  }

  function handleChangeRowsPerPage(event) {
    setPage(0);
    setRowsPerPage(+event.target.value);
    loadRecords({
      perPage: event.target.value,
      page: 0,
      search: inputSearch,
    });
  }

  function refreshAction() {
    loadRecords({
      page: pageCurrentState || page,
      search: inputSearch,
    });
  }

  if (reload) {
    refreshAction();
  }

  const generateMobileButtons = () => {
    return (
      <>
        {!props.hiddenReload && (
          <li className="kt-nav__item">
            <a href={void 0} className="kt-nav__link" onClick={refreshAction}>
              <i className="kt-nav__link-icon flaticon2-reload"></i>
              <span className="kt-nav__link-text">Atualizar</span>
            </a>
          </li>
        )}
        {props.buttons.length > 0
          ? props.buttons.map((btn, i) => {
              const btnOnClick = btn.endpoint
                ? () =>
                    exportRecords({
                      orderByDirection: order,
                      orderBy: orderBy,
                      search: inputSearch,
                      endpoint: btn.endpoint,
                      isEndpointFull: btn.isEndpointFull,
                    })
                : btn.onClick;

              return btn.path ? (
                <Link to={btn.path} className="kt-nav__item" key={i}>
                  <span className="kt-nav__link" onClick={btnOnClick}>
                    <i
                      className={`kt-nav__link-icon flaticon-${btn.icone}`}
                    ></i>
                    <span className="kt-nav__link-text">{btn.label}</span>
                  </span>
                </Link>
              ) : (
                <li className="kt-nav__item" key={i}>
                  <a
                    href={void 0}
                    className="kt-nav__link"
                    onClick={btnOnClick}
                  >
                    <i
                      className={`kt-nav__link-icon flaticon-${btn.icone}`}
                    ></i>
                    <span className="kt-nav__link-text">{btn.label}</span>
                  </a>
                </li>
              );
            })
          : null}
      </>
    );
  };

  return (
    <div
      className={`xv-datatable col-xl-12 ${props.className}`}
      style={{
        minHeight: "max-content",
        marginTop: "0px",
        padding: props.addButtonOpenDiv ? "0 0 0 0" : "0",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <StyledTableContent
        className="xv-datatable__surface"
        style={{
          maxHeight: "fit-content",
          backgroundColor: globalColors.backgroundColor5,
          boxShadow: props.removeTableShadow
            ? "none"
            : "0px 0px 10px 0px rgba(0,0,0,0.2)",
          padding: props.removePadding ? 0 : 16,
        }}
      >
        <Loading isLoading={isLoading || isLoadingExport} />

        <Portlet
          className="xv-datatable__portlet"
          fluidHeight={true}
          style={{
            backgroundColor: "transparent",
            boxShadow: "none",
            padding: 0,
            marginLeft: "8px",
            marginRight: "0px",
          }}
        >
          <div
            style={{
              padding: 0,
              margin: 0,
              height: props.hideTitle && !props.addButtonUrl ? 0 : "52px",
              marginTop: "5px",
            }}
          >
            {props.title && props.icon && (!props.hideTitle || props.addButtonUrl) ? (
              <AdminTitle
                icon={props.icon}
                title={props.title}
                disableHeader={props.disableHeader}
                width={props.width}
                mobile={props.mobile}
                backgroundColor={props?.backgroundColor}
                actions={props.actions}
                refreshAction={props.refreshAction}
                generateMobileButtons={generateMobileButtons}
                addButtonUrl={props.addButtonUrl}
                tooltip={props.tooltip}
                titleButon={props.titleButon}
                colorButton={props?.colorButton}
                removeMargin={props.removeTitleMargin}
                hideTitle={props.hideTitle}
              />
            ) : null}
          </div>

          {props.addSelect && props.addSelect}

          <PortletBody
            fit={true}
            fluid={true}
            style={{
              padding: 0,
            }}
          >
            <div className={`${classes.root} xv-datatable__root`}>
              {props.formView ? props.formView : null}

              {props.placeholderSearch ? (
                <div
                  className={`${classes.search} xv-datatable__search`}
                  style={{
                    border: "0.5 px solid red",
                  }}
                >
                  <Form.Row
                    className={`${classes.rows} xv-inline-filter-row`}
                    style={{
                      padding: "0 !important",
                      margin: 0,
                      backgroundColor: "transparent",
                    }}
                  >
                    <Grid container className="xv-inline-filter-grid">
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <Form.Group
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          <SvgIcon
                            component={SearchIcon}
                            viewBox="0 0 20 20"
                            stroke={globalColors.primaryColor5}
                            style={{
                              fontSize: "20px",
                              color: globalColors.primaryColor5,
                              position: "absolute",
                              left: "20px",
                              fill: "none",
                            }}
                          />
                          <Form.Control
                            type="text"
                            name="search"
                            style={{
                              paddingLeft: "60px",
                            }}
                            size="lg"
                            onChange={(e) => {
                              search(e);
                              setInputSearch(e.target.value);
                            }}
                            value={inputSearch}
                            className={`${classes.input}`}
                            placeholder={props.placeholderSearch}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SvgIcon
                                    component={SearchIcon}
                                    viewBox="0 0 20 20"
                                    stroke={globalColors.primaryColor5}
                                    style={{
                                      fontSize: "20px",
                                      color: globalColors.primaryColor5,
                                      fill: "none",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Form.Group>
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <Form.Group
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                            paddingRight: "10px",
                          }}
                        >
                          <InputForm
                            name="type"
                            placeholder="Selecione o status"
                            label="Status"
                            isSelect={true}
                            options={typeOptions}
                            value={selectedType}
                            onChange={handleTypeChange}
                            required={true}
                            isClearable
                          />
                        </Form.Group>
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                        <Form.Group
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          <InputDateForm
                            name="dateField"
                            label="Data Limite"
                            placeholder="Selecione uma data"
                            onChange={handleDateChange}
                            value={selectedDate}
                          />
                        </Form.Group>
                      </Grid>
                    </Grid>
                  </Form.Row>

                  {props.width >= 768 || !props.mobile ? (
                    props.buttons && props.buttons.length > 0 ? (
                      <>
                        {props.buttons.map((item, index) => (
                          <div className={classes.addBtn} key={index}>
                            <HeaderButton
                              path={item.path}
                              label={item.label}
                              onClick={
                                item.endpoint
                                  ? () =>
                                      exportRecords({
                                        orderByDirection: order,
                                        orderBy: orderBy,
                                        search: inputSearch,
                                        endpoint: item.endpoint,
                                        isEndpointFull: item.isEndpointFull,
                                      })
                                  : item.onClick
                              }
                              icone={item.icone}
                              disabled={item.disabled}
                            />
                          </div>
                        ))}
                        {!props.hiddenReload && (
                          <RefreshButton refreshAction={refreshAction} />
                        )}
                      </>
                    ) : null
                  ) : null}
                </div>
              ) : null}

              <div className={`${classes.tableContainer} xv-datatable__table-container`}>
                <Paper className={`${classes.paper} xv-datatable__paper`}>
                  <div className={`${classes.tableWrapper} xv-datatable__table-wrapper`}>
                    <Table
                      className={`${classes.table} xv-datatable__table`}
                      style={{
                        borderRadius: "4px 4px 0px 0px",
                      }}
                    >
                      <EnhancedTableHead
                        rowCount={rows?.length}
                        headRows={props.headRows}
                        styledTableCell={props.styledTableCell}
                      />
                      <TableBody
                        style={{
                          height: "32px",
                        }}
                      >
                        {isLoading ? (
                          <TableRow component={StyledTableRow}>
                            <TableCell
                              colSpan={props.headRows?.length}
                              className="text-center"
                              component={StyledTableCell}
                            >
                              Aguarde...
                            </TableCell>
                          </TableRow>
                        ) : count > 0 ? (
                          rows.map((row) => props.formatRow(row))
                        ) : (
                          <TableRow component={StyledTableRow}>
                            <TableCell
                              colSpan={props.headRows.length}
                              className="text-center"
                              component={StyledTableCell}
                            >
                              Nenhum registro encontrado.
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </div>
                </Paper>
              </div>
              <Table className="xv-datatable__pagination">
                <TableFooter
                  style={{
                    margin: 0,
                  }}
                >
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[]}
                      colSpan={10}
                      count={count ? count : 0}
                      rowsPerPage={rowsPerPage}
                      style={{
                        color: globalColors.backgroundColor2,
                        fontWeight: "400",
                        padding: "0 10px",
                        margin: 0,
                      }}
                      page={page ? page : 0}
                      id="MuiTable-root-custom"
                      labelRowsPerPage=""
                      labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} de ${count}`
                      }
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      ActionsComponent={(props) => (
                        <Container
                          maxWidth="sm"
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            right: "-10px",
                            fontSize: "17px",
                            color: globalColors.backgroundColor2,
                            fontWeight: "bold",
                            padding: 0,
                            margin: 0,
                            marginLeft: "25px",
                            width: "120px",
                          }}
                        >
                          <IconButton
                            onClick={() => props.onChangePage({}, 0)}
                            disabled={props.page === 0}
                            aria-label="Primeira Página"
                            style={{
                              width: "10px",
                            }}
                            sx={{
                              "&:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                          >
                            <SvgIcon
                              component={FirstPageIcon}
                              style={{
                                fontSize: "17px",
                                color:
                                  props.page === 0
                                    ? "#ccc"
                                    : globalColors.backgroundColor2,
                                fill: "none",
                              }}
                            />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              props.onChangePage({}, props.page - 1)
                            }
                            disabled={props.page === 0}
                            aria-label="Anterior"
                            style={{
                              width: "10px",
                            }}
                          >
                            <SvgIcon
                              component={PreviousPageIcon}
                              style={{
                                fontSize: "17px",
                                color:
                                  props.page === 0
                                    ? "#ccc"
                                    : globalColors.backgroundColor2,
                                fill: "none",
                              }}
                            />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              props.onChangePage({}, props.page + 1)
                            }
                            disabled={
                              props.page >=
                              Math.ceil(props.count / props.rowsPerPage) - 1
                            }
                            aria-label="Próxima"
                            style={{
                              width: "10px",
                            }}
                          >
                            <SvgIcon
                              component={NextPageIcon}
                              style={{
                                fontSize: "17px",
                                color:
                                  props.page >=
                                  Math.ceil(props.count / props.rowsPerPage) - 1
                                    ? "#ccc"
                                    : globalColors.backgroundColor2,
                                fill: "none",
                              }}
                            />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              props.onChangePage(
                                {},
                                Math.max(
                                  0,
                                  Math.ceil(props.count / props.rowsPerPage) - 1
                                )
                              )
                            }
                            disabled={
                              props.page >=
                              Math.ceil(props.count / props.rowsPerPage) - 1
                            }
                            aria-label="Última Página"
                            style={{
                              width: "20px",
                              padding: 0,
                              margin: 0,
                            }}
                            sx={{
                              "&:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                          >
                            <SvgIcon
                              component={LastPageIcon}
                              style={{
                                fontSize: "17px",
                                padding: 0,
                                margin: 0,
                                color:
                                  props.page >=
                                  Math.ceil(props.count / props.rowsPerPage) - 1
                                    ? "#ccc"
                                    : globalColors.backgroundColor2,
                                fill: "none",
                              }}
                            />
                          </IconButton>
                        </Container>
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </div>
          </PortletBody>
        </Portlet>
      </StyledTableContent>

      {props.addButtonOpenDiv ? (
        <ImageContainer showMap={isOpen}>
          <OpenContainerButton onClick={showMap}>
            {isOpen ? (
              <MdKeyboardArrowLeft className="arrow" />
            ) : (
              <MdKeyboardArrowRight className="arrow" />
            )}
          </OpenContainerButton>

          <img src={ImagemDefault} alt="Mapa do cemitério" />
        </ImageContainer>
      ) : null}
    </div>
  );
};

export default DatatableDocuments;
